(() => {
  if (window.__popupVideoInit) return;
  window.__popupVideoInit = true;

  const popups = document.querySelectorAll('.js-popup-video');
  popups.forEach(popup => {
    document.body.appendChild(popup);
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-open-popup-video');
    if (!btn) return;

    e.preventDefault();

    const blockId = btn.dataset.blockId;
    if (!blockId) return;

    const popup = document.querySelector(`.js-popup-video[data-block-id="${blockId}"]`);
    if (!popup) return;

    popup.classList.add('display');

    requestAnimationFrame(() => {

      setTimeout(() => {
        popup.classList.add('show');
      }, 50);
    });
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-close-popup-video');
    if (!btn) return;

    e.preventDefault();

    const popup = btn.closest('.js-popup-video');
    if (!popup) return;

    popup.classList.add('closing');

    setTimeout(() => {
      popup.classList.remove('closing', 'show', 'display');
    }, 300);
  });
})();

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".js-play-inline-video");

  buttons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const parent = btn.parentElement;
      if (!parent) return;

      const video = parent.querySelector("video");
      if (!video) return;

      document.querySelectorAll(".js-play-inline-video").forEach((otherBtn) => {
        const otherParent = otherBtn.parentElement;
        if (!otherParent) return;

        if (otherParent !== parent) {
          const otherVideo = otherParent.querySelector("video");
          if (otherVideo) {
            otherParent.classList.remove("active");
            otherVideo.pause();
          }
        }
      });

      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
        video.pause();
        return;
      }

      parent.classList.add("active");

      const tryPlay = () => {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener("loadeddata", tryPlay, { once: true });
      }
    });
  });
});